module.exports = __webpack_public_path__ + "img/1644_c.29d8a585.png";